import request from '@/utils/request';

//列表数据
export function getQueryStaffTransLogPage(values) {
  return request('/coupon/queryStaffTransLogPage', {
    method: 'POST',
    data: values,
  });
}
